<template>
  <!-- 课程质量报告 -->
  <div class="paginations">
    <div class="table-search-box table-search-box-haeder">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <el-form-item label="课程名称：">
          <el-input size="small" v-model="searchData.courseName" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item label="年份：">
          <el-select size="small" v-model="searchData.year" placeholder="请选择年份" :popper-append-to-body="false" clearable>
            <el-option v-for="(item,index) in yearList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="search()"></i>
            <i class="pointer el-icon-refresh-left" @click="resetting"></i>
          </div>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="batchExportHandler" class="exportButton">批量导出</el-button>
        </el-form-item> -->

      </el-form>
    </div>
    <div class="table_box">
      <el-table :data="tableObj.list" ref="table" style="width: 100%">
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column prop="index" label="序号" width="120" align='center'></el-table-column>
        <el-table-column prop="coursename" label="课程名称" align='center'></el-table-column>
        <el-table-column prop="year" label="年份" align='center'></el-table-column>
        <el-table-column prop="createtime" label="数据分析截止时间" align='center'></el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <template v-if="scope.row.filePath === null">
              <i class="icona icon-see" title="查看课程质量报告" @click="seeMonth(scope.row,scope.$index)"></i>
            </template>

            <template v-else>
              <i class="icona icon-details" title="查看课程质量分析报告" @click="see(scope.row)"></i>
              <i class="icona icon-download" title="下载课程质量报告" @click="download(scope.row.filePath)"></i>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="tableObj.total" :jumpTo="tableObj.jumpTo" @currentChange="search"></pageNumber>
    </div>
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue' //分页

export default {
  components: {
    pageNumber
  },
  data() {
    return {
      searchData: {
        courseName: '',
        year: '',
        pageDto: {
          pageNum: 1,//当前显示的页面页码数
          pageSize: 10, //一页多少条数据
        },
      },
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      yearList: []
    }
  },
  created() {
    this.search()
    let date = new Date()
    let currentYear = date.getFullYear()
    for (let i = 0; i < 3; i++) {
      this.yearList.push((currentYear - i))
    }
  },
  methods: {
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1
      this.tableObj.jumpTo = type ? type : 1
      this.$axios.post(this.$apiurls.report_qualityReport_getTableList, this.searchData, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.list.length; i++) {
            res.data.list[i].createtime = res.data.list[i].createtime.substring(0, 10)
            if (this.searchData.pageDto.pageNum == 1) {
              res.data.list[i].index = i + 1
            } else {
              res.data.list[i].index = i + 1 + ((this.searchData.pageDto.pageNum - 1) * 10)
            }
          }
          this.tableObj.list = res.data.list
          this.tableObj.total = res.data.total
        }
      });
    },
    // 重置
    resetting() {
      this.searchData.courseName = ''
      this.searchData.year = ''
      this.search()
    },

    seeMonth(row, index) {
      let token = sessionStorage.getItem("lrmv2token");
      let zykId = sessionStorage.getItem("zykId");
      const news = this.$router.resolve({ name: '/exportQualityReport', query: { courseName: row.coursename, zykid:zykId,token:token, month: row.createtime.substring(0, 7), dateTime: row.createtime.substring(0, 10) } })
      window.open(`${news.location.name}${news.href}`, '_blank')
    },

    // 查看  pdf版本
    see(row) {
      window.open(row.filePath)
      // console.log(row);
      // const news = this.$router.resolve({ name: '/historyCourse', query: { courseName: encodeURIComponent(row.coursename), zykname: encodeURIComponent(row.zykname), createtime: encodeURIComponent(row.createtime.substring(0, 10)), schoolname: encodeURIComponent(row.schoolname) } })
      // window.open(`${news.location.name}${news.href}`, '_blank')
      // this.$router.push('/historyCourse')
    },
    // batchExportHandler() {
    //   let select = this.$refs.table.selection

    //   let selectZykidArr = select.map(item => {
    //     let zykid = item.userId
    //     return zykid
    //   })

    //   let selectNameArr = select.map(item => {
    //     let userName = item.userName
    //     return userName
    //   })

    //   let userId = selectZykidArr.join(",");
    //   let selectName = selectNameArr.join(",")

    //   this.$axios.post(this.$apiurls.exportBatchReport, {
    //     zykid: this.zykId,
    //     type: 1,
    //     param: { userid: userId, username: selectName }
    //   }).then(res => {
    //     window.open(`${this.$apiurls.downloadReport}?file_path=${res.data}`)

    //     // window.open(`${this.$apiurls.report_yaer_Monthly_downloadReportFile}?filePath=${res.data}`)
    //   })
    // },
    // 下载
    download(url) {
      window.open(`${this.$apiurls.report_yaer_Monthly_downloadReportFile}?filePath=${url}`)
    },
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" >
.table-search-box-haeder {
  height: 40px;
  margin-bottom: 20px;
}

.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.exportButton {
  height: 33px;
  margin-top: 5px;
  line-height: 0px;
  background: rgba(46, 62, 99, 0.79);
  border: none;
}

.exportButton:hover {
  background: rgba(46, 62, 99, 0.79);
  border: none;
}
</style>
